
// We need this because of decoupled orderValidation and service rendering.
const validatorFinalCleaning = (service) => {
  return (service.serviceGroup === 201) && service.obligatory === false && service.maxUnits === 1;
};

export default validatorFinalCleaning;